/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../common";
import type {
  TestCreateFromContract,
  TestCreateFromContractInterface,
} from "../../../contracts/test/TestCreateFromContract";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    name: "create",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    name: "tables",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TestCreateFromContractConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TestCreateFromContractConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TestCreateFromContract__factory extends ContractFactory {
  constructor(...args: TestCreateFromContractConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    registry: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<TestCreateFromContract> {
    return super.deploy(
      registry,
      overrides || {}
    ) as Promise<TestCreateFromContract>;
  }
  override getDeployTransaction(
    registry: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(registry, overrides || {});
  }
  override attach(address: string): TestCreateFromContract {
    return super.attach(address) as TestCreateFromContract;
  }
  override connect(signer: Signer): TestCreateFromContract__factory {
    return super.connect(signer) as TestCreateFromContract__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TestCreateFromContractInterface {
    return new utils.Interface(_abi) as TestCreateFromContractInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TestCreateFromContract {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TestCreateFromContract;
  }
}
